<template>
  <div class="indexPage">
    <div class="topInfo">
      <div
        class="colorBox"
        style="background-color: #00b5f9"
        @click="search('')"
      >
        <div>全部</div>
        <div>{{ headInfo.dataAll | 0 }}</div>
      </div>
      <div
        class="colorBox"
        style="background-color: #f8ba74"
        @click="search('0')"
      >
        <div>进行中</div>
        <div>{{ headInfo.dataOne | 0 }}</div>
      </div>
      <div
        class="colorBox"
        style="background-color: #86abef"
        @click="search('4')"
      >
        <div>已完成</div>
        <div>{{ headInfo.dataFive | 0 }}</div>
      </div>
    </div>
    <div class="projectList" v-for="(item, index) in tableData" :key="index">
      <div class="title">
        <span style="font-weight: 700" class="cusAdress">{{
          item.projectName
        }}</span>
        <span style="color: green" @click="goDetail(item)">添加日报>></span>
      </div>
      <div class="list" @click="goDetail(item)">
        <div>节点名称：{{ item.nodeName }}</div>
        <div class="date">
          <div>立项日期：{{ item.createDt | dataFormatT }}</div>
          <div>结项日期：{{ item.expectFinishTime | dataFormatT }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      headInfo: {},
      queryInfo: {
        currPage: 1,
        pageSize: 200,
        loginName: '',
        status: "",
        condition: {},
      },
      tableData: [],
    };
  },
  created() {
    if(this.$route.query.loginName){
      this.queryInfo.loginName = this.$route.query.loginName
    }else{
      this.queryInfo.loginName = this.decode(this.$route.query.identity);
    }
    // console.log("identity", this.$route.query.identity);
    // this.queryInfo.loginName = this.decode(this.$route.query.identity);
    // console.log("this.queryInfo.loginName", this.queryInfo.loginName);
    this.findHeadData();
    this.getListData();
  },
  methods: {
    //解密
    decode(str) {
      // Going backwards: from bytestream, to percent-encoding, to original string.
      return decodeURIComponent(
        atob(str)
          .split("")
          .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      );
    },
    search(status) {
      this.queryInfo.currPage = 1;
      this.queryInfo.pageSize = 10;
      this.queryInfo.status = status;
      this.getListData();
    },
    getListData() {
      // 获取列表
      var that = this;
      that.$http
        .post("/projectNodesMember/list", that.queryInfo)
        .then(function (response) {
          console.log(response.data.data);
          if (response.data.code == 200) {
            that.total = response.data.data.count;
            that.queryInfo.currPage = response.data.data.currPage;
            that.tableData = response.data.data.data;
          }
        });
    },
    goDetail(projectInfo) {
      this.$router.push({
        path: "/dailyDetail",
        query: { projectInfo: projectInfo,loginName:this.queryInfo.loginName},
      });
    },
    //头部数据查询
    findHeadData() {
      var that = this;
      var data = {
        loginName: that.queryInfo.loginName,
      };
      that.$http
        .post("/projectNodesLog/findHeadData", data)
        .then(function (response) {
          if (response.data.code == 200) {
            that.headInfo = response.data.data;
          }
        });
    },
  },
};
</script>

<style lang="less" scoped>
.indexPage {
  width: 100%;
  background-color: #efefef;
  .topInfo {
    background-color: #fff;
    padding: 1.25rem;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .colorBox {
      width: 30%;
      height: 5rem;
      text-align: center;
      padding-top: 1.2rem;
      box-sizing: border-box;
      div {
        width: 100%;
        height: auto;
      }
    }
  }
  .projectList {
    background-color: #fff;
    width: 100%;
    border: 1px solid #efefef;
    margin-bottom: 0.625rem;
    .title {
      padding: 0.625rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #efefef;
      .cusAdress {
        display: inline-block;
        width: 16.25rem;
        /* 关键代码 */
        text-overflow: ellipsis; /* 溢出显示省略号 */
        overflow: hidden; /* 溢出隐藏 */
        white-space: nowrap; /* 强制不换行 */
      }
    }
    .list {
      width: 100%;
      padding: 0.625rem;
      box-sizing: border-box;
      .date {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
  }
}
</style>